import { render, staticRenderFns } from "./landing-call.vue?vue&type=template&id=66b38d3e&scoped=true&"
import script from "./landing-call.vue?vue&type=script&lang=js&"
export * from "./landing-call.vue?vue&type=script&lang=js&"
import style0 from "./landing-call.vue?vue&type=style&index=0&id=66b38d3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b38d3e",
  null
  
)

export default component.exports